<div class="container">
  <lib-icon
    class="close-icon"
    icon="close"
    [isClickable]="true"
    (onClick)="dismiss()">
  </lib-icon>

  <img src="../../../../../assets/icons/tick-circle.svg" alt="" class="logo" />

  <div class="header">
    <p class="title-text">¡Listo, ya puedes hacer tu primer depósito!</p>
    <p class="subtitle-text" *ngIf="limitMessage">{{ limitMessage }}</p>
  </div>

  <app-section-message
    class="sign-nudge"
    type="informative"
    icon="../../../../../assets/icons/outline-document-text-1.svg"
    title="Para invertir necesitas tu contrato firmado."
    text="Te toma 2 minutos."
    actionLabel="Firmar ahora"
    (actionClick)="sign()">
  </app-section-message>

  <div class="footer">
    <div class="button-actions">
      <lib-ui-button
        [fullWidth]="true"
        size="l"
        (click)="deposit()"
        [label]="'Hacer mi primer depósito'"
      ></lib-ui-button>
    </div>

    <div class="validation-note">
      <img src="../../../../../assets/icons/schedule.svg" alt="" class="note-icon" />
      <span class="note-text">Seguimos validando tu perfil en paralelo.</span>
    </div>

    <lib-ui-button
      variant="text"
      size="l"
      [fullWidth]="false"
      (click)="dismiss()"
      [label]="'Lo haré después'"
    ></lib-ui-button>
  </div>
</div>
